import PubSub from "./PubSub";

export default async function fetchWithTimeout(
  url,
  options,
  timeout = 5000,
  context = ""
) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const eventPrefix = `fetch:${context}`;

  PubSub.publish(`${eventPrefix}:start`, { url });

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();

    if (data.success !== undefined) {
      PubSub.publish(`${eventPrefix}:success`, {
        url,
        data: {
          ...data.data,
          key: new URLSearchParams(options.body).get("key"),
        },
      });
      return { success: data.success, data: data.data };
    }

    PubSub.publish(`${eventPrefix}:success`, { url, data });
    return { success: true, data };
  } catch (error) {
    PubSub.publish(`${eventPrefix}:error`, { url, error: error.message });
    return { success: false, error: error.message };
  } finally {
    PubSub.publish(`${eventPrefix}:end`, { url });
  }
}
